import { render, staticRenderFns } from "./SwitchWithButtonEl.vue?vue&type=template&id=7aaa77a3&scoped=true&"
import script from "./SwitchWithButtonEl.vue?vue&type=script&lang=ts&"
export * from "./SwitchWithButtonEl.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchWithButtonEl.vue?vue&type=style&index=0&id=7aaa77a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaa77a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VSwitch})
